import React from 'react'
import { RoutineType } from '../../../domain/db/RoutineTypeDB'
import Iconify from '../../../components/Iconify'

type Props = {
  type: RoutineType
}

export const SequenceTypeIcon = ({ type }: Props) => {
  if (type === RoutineType.WEEKDAYS) {
    return <Iconify width={20} icon="bi:calendar-week"/>
  }
  return <Iconify width={20} icon="mdi:clipboard-list-outline"/>
}
